<template>
    <div class="loading-overlay" v-if="isLoading">
        <div class="flex items-center">
            <EstravelSVG class="hidden md:block"/>
            <EstravelSymbolSpinnerSVG class="spinning-logo"/>
            <span
                class="hidden ml-10 text-md font-semibold leading-none text-blue-300 md:block">{{
                    $t('nav.top.self_service')
                }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import EstravelSVG from "@/assets/static/icons-src/estravel.svg";
import EstravelSymbolSpinnerSVG from "@/assets/static/icons-src/estravel-symbol-spinner.svg";

@Component({
    components: {
        EstravelSVG,
        EstravelSymbolSpinnerSVG
    }
})
export default class Loading extends Vue {
    get isLoading(): boolean {
        return this.$store.getters.isFetchingCustomerInfo;
    }
}
</script>

<style>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ECF3FB;
    animation: fadeIn 0.3s ease-out;
    z-index: 1000;
}

.spinning-logo {
    animation: spin 1.5s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
    filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.2));
}

/* Keyframe Animations */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
